import { geo } from "./../../../api/geo.js";
import {
  getStores,
  getStoresSortByDisplayOrder
} from "../../../api/services/storeService.js";
import { operatingHours } from "../../../api/helpers/datetimeHelper.js";
import { mapMutations, mapActions } from "vuex";
export default {
  filters: {
    Capitalize: function(value) {
      return value.charAt(0).toUpperCase() + value.substr(1);
    }
  },

  computed: {
    show() {
      return this.populars.length > 0;
    },
    orderedResturants() {
      let copy = [...this.populars];
      let that = this;
      return copy.sort((a, b) => {
        let d1 = that.distance(a.Location.Latitude, a.Location.Longitude);
        let d2 = that.distance(b.Location.Latitude, b.Location.Longitude);
        return d1 - d2;
      });
    }
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),

    checkLocation() {
      let that = this;
      if (geo.support()) {
        geo.getPos(result => {
          that.pos = {
            lat: result.coords.latitude,
            long: result.coords.longitude
          };
        });
      }
    },
    distance(lat, long) {
      let res = 1;
      if (this.pos) {
        res = geo.distance(this.pos.lat, this.pos.long, lat, long, "K");
      }
      return res.toFixed(1);
    },
    getStores() {
      this.busy = true;
      let that = this;
      getStores()
        .get()
        .then(function(snapshot) {
          that.busy = false;
          that.setStoreLoaded();
          snapshot.docs.forEach(function(doc) {
            let rs = doc.data();
            if (!rs.IsHQ) that.populars.push(rs);
          });
        })
        .catch(reason => {
          that.busy = false;
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          ]);
          that.redirectToErrorPage();
        });
    },
    getnearStores() {
      this.busy = true;
      let xKilometer = 5;
      let that = this;
      getStoresSortByDisplayOrder()
        .get()
        .then(function(snapshot) {
          that.busy = false;
          snapshot.docs.forEach(function(doc) {
            let rs = doc.data();
            if (
              that.distance(rs.Location.Latitude, rs.Location.Longitude) <
              xKilometer
            ) {
              if (!rs.IsHQ) that.populars.push(rs);
            }
          });
        })
        .catch(reason => {
          that.busy = false;
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          ]);
          that.redirectToErrorPage();
        });
    },
    getOperatingHours(oh) {
      return operatingHours(oh);
    },
    navigateToGiftCardStore(rs) {
      this.$router.push({
        name: "giftstore",
        params: { storeid: rs.ID, storename: rs.Name.split(" ").join("-") }
      });
    },
    navigateToStore(rs) {
      this.$router.push({
        name: "store",
        params: { storeid: rs.ID, storename: rs.Name.split(" ").join("-") }
      });
    }
  }
};
